import React from "react";
import { Link } from "react-router-dom";

export default function Disclaimer() {
  const items = [
    {
      title: "1. Educational Purpose Only",
      text: "UPSC Titan Score offers mock tests, structured learning resources, premium study support, and performance analytics for educational purposes only. The platform does not guarantee selection, rank, interview call, or examination success."
    },
    {
      title: "2. No Official Affiliation",
      text: "UPSC Titan Score is an independent educational platform and is not affiliated with, endorsed by, or officially connected to the Union Public Service Commission (UPSC), Government of India, or any government authority."
    },
    {
      title: "3. Accuracy of Information",
      text: "We strive to provide reliable and updated educational content. However, we do not guarantee absolute completeness, accuracy, or suitability of every material. Users should always verify official notifications, syllabus changes, and announcements from authorized sources."
    },
    {
      title: "4. Limitation of Liability",
      text: "UPSC Titan Score shall not be held liable for any direct, indirect, incidental, or consequential loss, damage, or academic decision arising from the use of our platform, content, study tools, or learning materials."
    },
    {
      title: "5. External Links",
      text: "Our platform may include references or links to third-party resources for educational convenience. We are not responsible for the content, security, or privacy practices of external websites."
    }
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(239,68,68,0.07), transparent 22%), radial-gradient(circle at top right, rgba(56,189,248,0.08), transparent 24%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        color: "#fff"
      }}
    >
      <div className="container py-5">
        <div className="text-center mb-5">
          <div style={badgeStyle}>LEGAL INFORMATION</div>

          <h1
            className="fw-bold mt-4"
            style={{
              fontSize: "clamp(2rem, 5vw, 3.2rem)",
              background: "linear-gradient(90deg, #ffffff, #cbd5e1, #38bdf8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            Disclaimer
          </h1>

          <p
            className="mx-auto mt-3"
            style={{
              maxWidth: "860px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              fontSize: "1.03rem"
            }}
          >
            The information, services, and educational resources provided by
            UPSC Titan Score are intended strictly for{" "}
            <strong>learning and informational use</strong>.
          </p>
        </div>

        <div className="row g-4">
          {items.map((item, index) => (
            <div className="col-12" key={index}>
              <div style={sectionCardStyle}>
                <h4 className="fw-bold mb-3" style={{ color: "#f8fafc" }}>
                  {item.title}
                </h4>
                <p style={textStyle}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 text-center" style={ctaStyle}>
          <div style={badgeStyle}>IMPORTANT NOTICE</div>
          <h4 className="fw-bold mt-3 mb-3" style={{ color: "#ffffff" }}>
            Responsible Learning Starts With Verified Information
          </h4>
          <p
            className="mx-auto"
            style={{
              maxWidth: "860px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              marginBottom: "22px"
            }}
          >
            By using UPSC Titan Score, you acknowledge that you have read,
            understood, and accepted this Disclaimer. For exam-critical updates,
            always refer to official UPSC notifications and trusted government
            sources.
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Link to="/terms" className="btn btn-outline-light btn-lg px-4">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="btn btn-success btn-lg px-4">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const badgeStyle = {
  display: "inline-block",
  padding: "8px 16px",
  borderRadius: "999px",
  background: "rgba(56,189,248,0.12)",
  border: "1px solid rgba(56,189,248,0.20)",
  color: "#7dd3fc",
  fontWeight: 700,
  fontSize: "13px",
  letterSpacing: "1px"
};

const sectionCardStyle = {
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.92), rgba(17,24,39,0.88))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "24px",
  padding: "26px",
  boxShadow: "0 14px 34px rgba(0,0,0,0.24)"
};

const textStyle = {
  color: "#94a3b8",
  lineHeight: "1.9",
  fontSize: "0.98rem",
  marginBottom: 0
};

const ctaStyle = {
  background:
    "linear-gradient(145deg, rgba(2,6,23,0.96), rgba(15,23,42,0.92))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "30px",
  padding: "42px 24px",
  boxShadow: "0 18px 40px rgba(0,0,0,0.28)"
};